import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { SketchPicker } from 'react-color';
import TextField from '@material-ui/core/TextField';

export default function ColorPicker(props) {

    const classes = useStyles();
    const [showColorPalette, setShowColorPalette] = useState(false);
    const colorPickerRef = useRef();

    useEffect(
        () => {
            if (showColorPalette) {
                window.addEventListener("click", handleClick);
            }
            return () => window.removeEventListener("click", handleClick);
        }, [showColorPalette]
    )

    const handleClick = (e) => {
        console.log(e.target);
        if (colorPickerRef.current && showColorPalette) {
            if (!colorPickerRef.current.contains(e.target)) {
                setShowColorPalette(false);
            }
        }
    }


    return (
        <React.Fragment>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField id="standard-basic" label={props.label} onChange={(e)=>props.setSelectedColor(e.target.value)} value={props.selectedColor} style={{ width: '200px' }} />
                <span onClick={() => setShowColorPalette(!showColorPalette)} className={classes.colorButton} style={{ backgroundColor: props.selectedColor, cursor:'pointer' }}></span>
            </div>
            <div>
                {
                    showColorPalette ?
                        <div className={classes.colorPickerWrapper} ref={colorPickerRef}>
                            <SketchPicker
                                color={props.selectedColor}
                                onChangeComplete={(e) => props.setSelectedColor(e.hex)}
                            />
                        </div>
                        : null
                }
            </div>
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    root: {
    },
    colorPickerWrapper: {
        position: 'absolute',
        zIndex: 10,
        width: '200px',
    },
    colorButton: { "width": "25px", "height": "25px", "display": "inline-block" },
});